/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Company-level switch for the family member feature.
 * @export
 */
export const WebApiModelsEnumerationTypesFamilyMemberConfiguration = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesFamilyMemberConfiguration = typeof WebApiModelsEnumerationTypesFamilyMemberConfiguration[keyof typeof WebApiModelsEnumerationTypesFamilyMemberConfiguration];


export function WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSON(json: any): WebApiModelsEnumerationTypesFamilyMemberConfiguration {
    return WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesFamilyMemberConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesFamilyMemberConfiguration {
    return json as WebApiModelsEnumerationTypesFamilyMemberConfiguration;
}

export function WebApiModelsEnumerationTypesFamilyMemberConfigurationToJSON(value?: WebApiModelsEnumerationTypesFamilyMemberConfiguration | null): any {
    return value as any;
}

